import DefaultLayout from '../components/Pages/Layout/DefaultLayout.vue';
import NotFound from '../components/GeneralViews/NotFoundPage.vue';

const Overview = () => import('src/components/Pages/Views/Store/Overview.vue');
const StoreStatus = () => import('src/components/Pages/Views/Store/StoreStatus.vue');
const StoreManagement = () => import('src/components/Pages/Views/Store/StoreManagement.vue');
const StoreRegistration = () => import('src/components/Pages/Views/Store/StoreRegistration.vue');
const StoreFloorEdit = () => import('src/components/Pages/Views/Store/StoreFloorEdit.vue');
const StoreStatusPrint = () => import('src/components/Pages/Views/Store/StoreStatusPrint.vue');
const MediaEditPage = () => import('src/components/Pages/Views/Store/MediaEditPage');

const AdvertiserManagement = () => import('src/components/Pages/Views/Advertiser/AdvertiserManagement.vue');
const AdvertiserContract = () => import('src/components/Pages/Views/Advertiser/AdvertiserContract.vue');
const ModusignContract = () => import('@/components/Pages/Views/modusign/ModusignContract.vue');
const MediaDetailPage = () => import('src/components/Pages/Views/Advertiser/MediaDetailPage');

const OrderManagement = () => import('src/components/Pages/Views/Order/OrderManagement.vue');

const MediaRegistration = () => import('src/components/Pages/Views/Media/MediaRegistration.vue');
const MediaExcelRegistration = () => import('src/components/Pages/Views/Media/MediaExcelRegistration.vue');
const MediaExcelList = () => import('src/components/Pages/Views/Media/MediaExcelList.vue');
const MediaManagement = () => import('src/components/Pages/Views/Media/MediaManagement.vue');
const MediaManagementRegistration = () => import('src/components/Pages/Views/Media/MediaManagementRegistration.vue');

const SettingsAccount = () => import('src/components/Pages/Views/Settings/SettingsAccount.vue');
const SettingsAdvertiser = () => import('src/components/Pages/Views/Settings/SettingsAdvertiser.vue');
const SettingsAccountRegistration = () => import('src/components/Pages/Views/Settings/SettingsAccountRegistration.vue');
const SettingsAccountSubUserList = () => import('src/components/Pages/Views/Settings/SettingsAccountSubUserList.vue');
const SettingsCompany = () => import('src/components/Pages/Views/Settings/SettingsCompany.vue');
const SettingsCompanyRegistration = () => import('src/components/Pages/Views/Settings/SettingsCompanyRegistration.vue');
const SettingsAuthority = () => import('src/components/Pages/Views/Settings/SettingsAuthority.vue');
const SettingsHomeInfo = () => import('src/components/Pages/Views/Settings/SettingsHomeInfo.vue');
const SettingsInfo = () => import('src/components/Pages/Views/Settings/SettingsInfo.vue');
const SettingsRoleAuth = () => import('src/components/Pages/Views/Settings/SettingsRoleAuth.vue');

const BoardLayout = () => import('@/components/Pages/Layout/BoardLayout.vue')

// modusing redirect
import ModusignRedirect from '@/components/Pages/Views/modusign/ModusignRedirect.vue'
let modusignRedirect = {
  path: '/modusign/:type',
  name: 'ModusignRedirect',
  component: ModusignRedirect
}


// Home
import Home from 'src/components/Pages/Views/Home/Home-2023.vue';
import Login from 'src/components/Pages/Views/Home/Login.vue';
import Join from 'src/components/Pages/Views/Home/Join.vue';
import ContactUs from "../components/Pages/Views/Home/ContactUs";
import MediaInfo from "../components/Pages/Views/Home/MediaInfo";
import MainMedia from "../components/Pages/Views/Home/MainMedia.vue";
import FindId from 'src/components/Pages/Views/Home/FindId.vue'
import FindPwd from 'src/components/Pages/Views/Home/FindPwd.vue'
import FindPwdConfirm from 'src/components/Pages/Views/Home/FindPwConfirm.vue'
import ChangePw from 'src/components/Pages/Views/Home/ChangePw.vue'

let homePage = {
  path: '/home',
  name: 'Home',
  component: Home
};

let loginPage = {
  path: '/login',
  name: 'Login',
  component: Login
};

let joinPage = {
  path: '/join',
  name: 'Join',
  component: Join
};

const findId = {
  path: '/find-id',
  name: 'findId',
  component: FindId
}

const findPwd = {
  path: '/find-pwd',
  name: 'findPwd',
  component: FindPwd
}

const findPwdConfirm = {
  path: '/reset/:uuid',
  name: 'FindPwdConfirm',
  component: FindPwdConfirm
}

const changePw = {
  path: '/change-pw',
  name: 'ChangePw',
  component: ChangePw
}

let mediaInfoPage = {
  path: '/media-info',
  name: 'MediaInfo',
  component: MainMedia
};

let contactUsPage = {
  path: '/contactus',
  name: 'ContactUs',
  component: ContactUs
};

let storeStatusPrint = {
  path: '/store/status/print',
  name: 'StoreStatusPrint',
  component: StoreStatusPrint
};

let mediaEditPage = {
  path: '/store/:storeSeq/advertisement/:advertisementSeq',
  mame: 'MediaEditPage',
  component: MediaEditPage
};

let mediaDetailPage = {
  path: '/advertiser/store/:storeSeq/floor/:storeFloorSeq/advertisement/:advertisementSeq',
  mame: 'MediaDetailPage',
  component: MediaDetailPage
};

/**
 * 점포관리
 * @type {{path: string, component: *, children: *[], name: string}}
 */
let storeManagement = {
  path: '/store',
  name: 'Store',
  component: DefaultLayout,
  children: [
    {
      path: 'overview',
      name: 'StoreOverview',
      meta: {
        auth: true,
      },
      component: Overview
    },
    {
      path: 'status',
      name: 'StoreStatus',
      meta: {
        auth: true,
      },
      component: StoreStatus
    },
    {
      path: 'management',
      name: 'StoreManagement',
      meta: {
        auth: true,
      },
      component: StoreManagement
    },
    {
      path: 'management/registration',
      name: 'StoreRegistration',
      meta: {
        auth: true,
      },
      component: StoreRegistration
    },
    {
      path: 'management/registration/:storeSeq',
      name: 'StoreEdit',
      meta: {
        auth: true,
      },
      component: StoreRegistration
    },
    {
      path: 'management/:storeSeq/store-floors/:storeFloorSeq',
      name: 'StoreFloorEdit',
      meta: {
        auth: true,
      },
      component: StoreFloorEdit
    },

  ]
};

/**
 * 광고주 관리
 * @type {{path: string, component: *, children: *[], mane: string}}
 */
let advertiserManagement = {
  path: '/advertiser',
  name: 'Advertiser',
  component: DefaultLayout,
  children: [
    {
      path: 'management',
      name: 'AdvertiserManagement',
      meta: {
        auth: true,
      },
      component: AdvertiserManagement
    },
    {
      path: 'contract',
      name: "AdvertiserContract",
      meta: {
        auth: true,
      },
      component: AdvertiserContract
    },
    {
      path: 'modusign',
      name: "ModusignContract",
      meta: {
        auth: true,
      },
      component: ModusignContract
    }

  ]
};

/**
 * 발주관리
 * @type {{path: string, component: *, children: {path: string, component: *, name: string}[], name: string}}
 */
let orderManagement = {
  path: '/order',
  name: 'Order',
  component: DefaultLayout,
  children: [
    {
      path: 'management',
      name: "OrderManagement",
      meta: {
        auth: true,
      },
      component: OrderManagement
    }
  ]
};

/**
 * 매체관리
 * @type {{path: string, component: *, children: *[], name: string}}
 */
let mediaManagement = {
  path: '/media',
  name: 'Media',
  component: DefaultLayout,
  children: [
    {
      path: 'registration',
      name: "MediaRegistration",
      meta: {
        auth: true,
      },
      component: MediaRegistration
    },
    {
      path: 'excel',
      name: "MediaExcelList",
      meta: {
        auth: true,
      },
      component: MediaExcelList
    },
    {
      path: 'excel-upload',
      name: "MediaExcelRegistration",
      meta: {
        auth: true,
      },
      component: MediaExcelRegistration
    },
    {
      path: 'management',
      name: "MediaManagement",
      meta: {
        auth: true,
      },
      component: MediaManagement
    },
    {
      path: 'management/registration',
      name: "MediaManagementRegistration",
      meta: {
        auth: true,
      },
      component: MediaManagementRegistration
    },
    {
      path: 'management/registration/:mediaInfoSeq',
      name: "MediaManagementEdit",
      meta: {
        auth: true,
      },
      component: MediaManagementRegistration
    },
  ]
};

/**
 * 환경관리
 * @type {{path: string, component: *, children: *[], name: string}}
 */
let settingsManagement = {
  path: '/settings',
  name: 'Settings',
  component: DefaultLayout,
  children: [
    {
      path: 'account',
      name: "SettingsAccount",
      meta: {
        auth: true,
      },
      component: SettingsAccount
    },{
      path: 'advertiser',
      name: "SettingsAdvertiser",
      meta: {
        auth: true,
      },
      component: SettingsAdvertiser
    },{
      path: 'account/registration',
      name: "SettingsAccountRegistration",
      meta: {
        auth: true,
      },
      component: SettingsAccountRegistration
    },
    {
      path: 'account/registration/:userId',
      name: "SettingsAccountEdit",
      meta: {
        auth: true,
      },
      component: SettingsAccountRegistration
    },
    {
      path: 'account/sub-user/:companySeq',
      name: 'SettingsAccountSubUserList',
      meta: {
        auth: true,
      },
      component: SettingsAccountSubUserList,
    },
    {
      path: 'company',
      name: "SettingsCompany",
      meta: {
        auth: true,
      },
      component: SettingsCompany
    },
    {
      path: 'company/registration',
      name: "SettingsCompanyRegistration",
      meta: {
        auth: true,
      },
      component: SettingsCompanyRegistration
    },
    {
      path: 'authority',
      name: "SettingsAuthority",
      meta: {
        auth: true,
      },
      component: SettingsAuthority
    },
    {
      path: 'authority/:roleCode',
      name: "SettingsRoleAuth",
      meta: {
        auth: true,
      },
      component: SettingsRoleAuth
    },
    {
      path: 'home-info',
      name: "SettingsHomeInfo",
      meta: {
        auth: true,
      },
      component: SettingsHomeInfo
    },
    {
      path: 'info',
      name: "SettingsInfo",
      meta: {
        auth: true,
      },
      component: SettingsInfo
    },
  ]
};


const board = {
  path: '/:layout/board',
  name: 'Board',
  component: BoardLayout,
  children: [{
    path: 'list/:boardNo',
    name: "ArticleList",
    component: () => import('@/components/Pages/Views/Board/ArticleList.vue')
  },{
    path: 'write/:boardNo',
    name: "ArticleWrite",
    component: () => import('@/components/Pages/Views/Board/ArticleWrite.vue'),
    props: { mode: 'write' }
  },{
    path: 'edit/:boardNo/:articleNo',
    name: "ArticleEdit",
    component: () => import('@/components/Pages/Views/Board/ArticleWrite.vue'),
    props: { mode: 'edit' }
  },{
    path: 'reply/:boardNo/:articleNo',
    name: "ArticleReply",
    component: () => import('@/components/Pages/Views/Board/ArticleReply.vue')
  },{
    path: 'view/:boardNo/:articleNo',
    name: "ArticleView",
    component: () => import('@/components/Pages/Views/Board/ArticleView.vue')
  }]
}

const routes = [
  {
    path: '/',
    component: Home,
    redirect: '/home',
  },
  modusignRedirect,
  homePage,
  loginPage,
  joinPage,
  findId,
  findPwd,
  findPwdConfirm,
  changePw,
  board,
  contactUsPage,
  mediaInfoPage,
  storeManagement,
  advertiserManagement,
  orderManagement,
  mediaManagement,
  settingsManagement,
  storeStatusPrint,
  mediaEditPage,
  mediaDetailPage,
  {path: '*', component: NotFound}
];

export default routes
